export default __webpack_public_path__ + "static/nbcbayarea-7517e3e1f1f073f8dd15d715ede1da33.svg";